<template>
    <ModalTheme :with-content="true" @close="closeModal" :theme="true">
        <template slot="main">
            <NotificationLists ref="notificationList" @cancel="closeModal" v-if="brandId" :brandId="brandId"></NotificationLists>
        </template>
        <template slot="footer">
            <ClientColorButton :disabled="!isDirty" @click.prevent="closeModal">{{ $t("common.cancel") }}</ClientColorButton>
            <ClientColorButton :disabled="!isDirty" @click="save">{{ $t("common.save") }} </ClientColorButton>
        </template>
    </ModalTheme>
</template>

<script>
import { mapGetters } from "vuex";
import TryLoadMixin from "@/mixins/TryLoadMixin";
import ModalTheme from "@/components/ui/ModalTheme";
import ClientColorButton from "@/components/ui/ClientColorButton";
import loader from "@/components/loader/loader";
import NotificationLists from "@/components/admin/notifcation-lists/NotificationLists";
import { EventBus, EVENTS } from "@/components/admin/notifcation-lists/EventBus";

export default {
    data() {
        return {
            brandId: undefined,
            isDirty: false
        };
    },
    mixins: [TryLoadMixin],
    components: {
        NotificationLists,
        ModalTheme,
        loader,
        ClientColorButton
    },
    mounted() {
        EventBus.$on(EVENTS.UPDATE_IS_DIRTY, payLoad => {
            this.isDirty = payLoad;
        });
    },
    methods: {
        closeModal() {
            this.$emit("close");
        },
        save() {
            this.$refs.notificationList.saveNotificationLists();
        }
    },
    computed: {
        ...mapGetters({
            getBrand: "items/getBrand"
        })
    },
    async created() {
        this.brandId = this.getBrand.id;
    }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// NotificationListsModal.vue?47da3a3f